// extracted by mini-css-extract-plugin
module.exports = {"form":"ProfileForm_form__3mnG7","control":"ProfileForm_control__um6jw","action":"ProfileForm_action__AEN1q"};